import type { TOC } from '@ember/component/template-only';
import { t } from 'ember-intl';
import type { BenchmarkInsightCompetitorsCompetitor } from 'lumen/models';

import styles from './competitors-list-headers.module.css';

interface HotelBenchmarkInsightCompetitorsCompetitorsListHeadersSignature {
  Args: {
    compset: BenchmarkInsightCompetitorsCompetitor[];
    isLoading: boolean;
  };
}

const HotelBenchmarkInsightCompetitorsCompetitorsListHeaders = <template>
  <div class={{styles.container}}>
    <div>
      <span class={{styles.hotel-name}}>
        {{t "general.hotelname"}}
      </span>
      {{#if @compset.length}}
        <span>|
          {{t
            "settings.competitors.nr_of_unique_competitors"
            count=@compset.length
          }}
        </span>
      {{/if}}
    </div>
    <div></div>
    <div class={{styles.hotel-distance}}>
      {{t "settings.competitors.table.distance"}}
    </div>
  </div>
</template> satisfies TOC<HotelBenchmarkInsightCompetitorsCompetitorsListHeadersSignature>;

export default HotelBenchmarkInsightCompetitorsCompetitorsListHeaders;
